<script setup lang="ts">
const profile = useProfileStore();
</script>

<template>
  <SongDetailsAlert
    message-variant="bg-warning"
    :title="$t('S.LIT_SignIn_Message')"
    icon="fa-light fa-circle-info"
    :button-label="$t('S.LIT_SignInTC')"
    button-variant="transparent-white"
    button-icon="fa-solid fa-user"
    :href="profile.signInUrl"
  />
</template>

<style scoped lang="postcss"></style>
